import { StyleSheet } from 'aphrodite';
import { THEME } from '@Theme';

const { colors, spacing, typography } = THEME;

export const emailDomainRequestDialogStyles = StyleSheet.create({
	// v2 Dialog override: widen the default popup so the domain input + availability actions fit on one row.
	dialogPopup: {
		maxWidth: 640,
		width: '100%',
	},
	description: {
		color: colors.text.dark,
		marginBottom: spacing.md,
		lineHeight: 1.5,
	},
	domainNameWrap: {
		display: 'flex',
		alignItems: 'flex-end',
		gap: spacing.md,
		margin: `${spacing.md}px 0`,
	},
	domainNameInputWrap: {
		flex: 1,
	},
	labelRow: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: spacing.xs,
		marginBottom: spacing.sm,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
	},
	errorRequired: {
		color: colors.danger.main,
	},
	infoTrigger: {
		display: 'inline-flex',
		alignItems: 'center',
		cursor: 'pointer',
	},
	infoContent: {
		maxWidth: 220,
	},
	infoMessage: {
		margin: 0,
		fontSize: typography.fontSizes.xxs,
		color: colors.text.main,
		lineHeight: 1.4,
	},
	inputWrap: {
		position: 'relative',
	},
	input: {
		width: '100%',
		// Reserve room for the absolutely-positioned availability icon.
		paddingRight: 28,
	},
	inputError: {
		borderColor: colors.danger.main,
	},
	availabilityIcon: {
		position: 'absolute',
		top: '50%',
		right: spacing.sm,
		transform: 'translateY(-50%)',
		display: 'flex',
	},
	availabilityActions: {
		display: 'flex',
		gap: spacing.sm,
		flexShrink: 0,
	},
	loaderWrap: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: 100,
		width: '100%',
	},
});
